import { defineNuxtRouteMiddleware } from '#imports'

export default (statusCode?: number) =>
  defineNuxtRouteMiddleware(async () => {
    throw showError({ statusCode })
  })
